import type { OnInit } from '@angular/core'
import { Component } from '@angular/core'
import { TitleService } from '../title.service'
import { environment } from '../../environments/environment'
import { LoggingService } from '../logging.service'
import { CartServiceService } from '../cart-service.service'

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
    enableTakeout = environment.takeoutEnable
    enableDineIn = environment.dineInMenuEnable
    enablePay = environment.payEnable
    enableLogin = environment.loginEnable

    constructor(
        private cart: CartServiceService,
        private logger: LoggingService,
        private titleService: TitleService
    ) {}

    ngOnInit(): void {
        this.logger.clear()
        this.logger.info('Landing', 'View Landing')
        this.titleService.setTitle(environment.titleFull, environment.titleFull)
        this.cart.reset().subscribe()
    }
}
